module.exports = "https://qp-assets.quero.com/assets/images/new-qp-logo.svg?71b053891e907472eae6eb6e3cb1959c";